export default __webpack_public_path__ + "static/media/email-icon.314b6fbb.png";